import {
  ConnectAccountManagement,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js"
import PropTypes from "prop-types"
import React from "react"

const StripeConnectAccountManagement = ({
  stripeConnectInstance,
  onUpdate,
}) => {
  const handleAccountUpdate = () => {
    if (onUpdate) {
      onUpdate()
    }
  }

  if (!stripeConnectInstance) {
    return null
  }

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectAccountManagement onUpdate={handleAccountUpdate} />
    </ConnectComponentsProvider>
  )
}

StripeConnectAccountManagement.propTypes = {
  stripeConnectInstance: PropTypes.object,
  onUpdate: PropTypes.func,
}

export default StripeConnectAccountManagement
